import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import Toggle from 'components/ReusableComponents/Toggle/index'
import { Link } from 'react-router-dom'
import { messagingKindsToPaths } from 'features/Messaging/messaging-helpers'
import useCopyText from 'hooks/useCopyText'

import styles from './DailyConversations.module.scss'

function getShortDate(date) {
  return date.toISOString().split('T')[0]
}

const ChatView = ({
  activeChat,
  activeChatId,
  reviewedConversations,
  flaggedConversations,
  setReviewedConversations,
  setFlaggedConversations,
  onAddToSpamList,
  date
}) => {
  const copy = useCopyText()

  if (!activeChat) return null

  return (
    <div className={styles.chat}>
      <div className={styles.chatHeader}>
        <Toggle
          label="Reviewed"
          checked={reviewedConversations?.[getShortDate(date)]?.[activeChatId]}
          handleChange={e =>
            setReviewedConversations({
              ...reviewedConversations,
              [getShortDate(date)]: {
                ...reviewedConversations[getShortDate(date)],
                [activeChatId]: e.target.checked
              }
            })
          }
        />
        <Toggle
          label="Flagged"
          checked={flaggedConversations?.[getShortDate(date)]?.[activeChatId]}
          handleChange={e =>
            setFlaggedConversations({
              ...flaggedConversations,
              [getShortDate(date)]: {
                ...flaggedConversations[getShortDate(date)],
                [activeChatId]: e.target.checked
              }
            })
          }
        />
        <Link
          to={`/s/${activeChat.subsidiaryId}/${messagingKindsToPaths[activeChat.kind]}/${
            activeChat.chatId
          }`}
          className={styles.goToChatButton}
        >
          <PrimaryRegularButton>Go to chat</PrimaryRegularButton>
        </Link>
      </div>
      <div className={styles.bubbles}>
        {activeChat.messages?.map((m, index) => (
          <div key={m.chatMessageId || m.chatId || index}>
            <div className={styles.bubbleHolder}>
              <div
                className={m.isSenderClient ? styles.clientBubble : styles.agentBubble}
                onClick={() => copy(m.content)}
              >
                {m.content}
              </div>
              {m.isSenderClient && (
                <PrimarySmallButton
                  className={styles.spamButton}
                  onClick={() => onAddToSpamList(m.content)}
                >
                  Mark as spam
                </PrimarySmallButton>
              )}
            </div>
            {(m.botIntent || m.botContext) && (
              <div className={styles.details}>
                {m.botIntent && (
                  <div className={styles.detail}>Intent: {m.botIntent}</div>
                )}
                {m.botContext && (
                  <div className={styles.detail}>Action: {m.botContext}</div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ChatView

